import api from './api';

const UserService = {
    // Profile
    getProfile: async () => {
        return api.get('users/me/');
    },

    updateProfile: async (data) => {
        return api.patch('users/update_profile/', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    // Addresses
    getAddresses: async () => {
        return api.get('users/addresses/');
    },

    addAddress: async (data) => {
        return api.post('users/addresses/', data);
    },

    updateAddress: async (id, data) => {
        return api.put(`users/addresses/${id}/`, data);
    },

    deleteAddress: async (id) => {
        return api.delete(`users/addresses/${id}/`);
    },

    setDefaultAddress: async (id) => {
        return api.post(`users/addresses/${id}/set_default/`);
    },

    // Saved Cards
    getSavedCards: async () => {
        return api.get('payments/saved-cards/');
    },

    deleteSavedCard: async (id) => {
        return api.delete(`payments/saved-cards/${id}/`);
    },

    // Security
    changePassword: async (data) => {
        return api.post('users/change_password/', data);
    }
};

export default UserService;
